export const chartType = {
  pie: 1,
  line: 2,
  barV: 3,
  barH: 4,
  donut: 5,
}

export default {
  chartType
}
